import { Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import * as React from "react";
import { Button } from "react-admin";

interface Props {
  isLocalRepair?: boolean;
}

const LocalRepairWarningDialog: React.FC<Props> = ({ isLocalRepair }) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(!!isLocalRepair);
  }, [isLocalRepair]);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose} disableRestoreFocus>
      <DialogTitle>LOCAL REPAIR</DialogTitle>
      <Divider />
      <DialogContent>
        <p style={{ margin: 0 }}>This Part is in Local Repair List.</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} label="OK" />
      </DialogActions>
    </Dialog>
  );
};

export default LocalRepairWarningDialog;
